import { Directive } from '@angular/core';
import { Learnspace, LearnspaceUserRole } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { ActivatedRoute } from '@angular/router';
import { switchMap, filter } from 'rxjs/operators';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { LearnspaceEditDialogComponent } from '@app/main/learnspaces/learnspace-edit-dialog/learnspace-edit-dialog.component';
import { AuthenticationService } from '@shared/services/authentication.service';
import { Router } from '@angular/router';
import { CurrentContextService } from '@shared/services/currentContextService';
import { TemplatePickerDialogComponent } from '@shared/components/template-picker-dialog/template-picker-dialog.component';
// import { BreadCrumb } from '@shared/components/breadcrumbs/breadcrumb.model';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { courseLabel, spaceLabel } from '@shared/utils/wording.utils';

@Directive()
export abstract class LearnspaceDetailBaseComponent {
  public xpLeft: number;
  public xpAllowed: number;
  // public breadcrumbs: BreadCrumb[];

  constructor(
    protected _authservice: AuthenticationService,
    protected _courseApiService: CoursesAPIService,
    protected _CurrentContextService: CurrentContextService,
    protected _dialog: MatDialog,
    protected _route: ActivatedRoute,
    protected _authService: AuthenticationService,
    protected _router: Router,
    protected _currentHubService: CurrentHubService
  ) {
  }

  setup(ls: Learnspace) {
    const xpCount = ls.experienceCount;
    this.xpAllowed = this._currentHubService.plan.maxCourse;
    if(this.xpAllowed !== Infinity) {
      this.xpLeft = Math.max(this.xpAllowed as number - xpCount, 0);
    } else {
      this.xpLeft = undefined;
    }
    // this.breadcrumbs = [
    //   new BreadCrumb(null, 'home', () => {
    //     this._router.navigate([this._currentHubService.getHubURLTitle()])
    //   }),
    //   new BreadCrumb(ls.title, null, null)
    // ]
  }

  canCreateXp(): boolean {
    return this.xpAllowed === Infinity || this.xpLeft > 0;
  }

  canEdit(learnspace: Learnspace): boolean {
    return learnspace.lsRole !== LearnspaceUserRole.learner || this._currentHubService.canAdminCurrentHub();
  }

  canDelete(ownerId: string): boolean {
    return ownerId === this._authservice.wondaUser.id || this._currentHubService.canAdminCurrentHub();
  }

  updateLearnspace(ls: Learnspace): void {
    this._dialog
      .open(LearnspaceEditDialogComponent, { width: '50vw', panelClass: 'learnspace-theme', data: { learnspace: ls } })
      .afterClosed()
      .subscribe();
  }

  deleteLearnspace(ls: Learnspace): void {
    this._dialog
      .open(ConfirmationDialogComponent, {
        width: '400px',
        height: 'auto',
        panelClass: 'learnspace-theme',
        data: { title: ls.title, type: spaceLabel(ls.mode) }
      })
      .afterClosed()
      .pipe(
        filter(val => val === 'ok'),
        switchMap(a => {
          return this._courseApiService.deleteLearnspace(ls.id);
        })
      )
      .subscribe(() => this._router.navigate([`/`]));
  }

  unsubscribeToLearnspace(ls: Learnspace): void {
    this._dialog
      .open(ConfirmationDialogComponent, {
        width: '400px',
        height: 'auto',
        panelClass: 'learnspace-theme',
        data: {
          title: `Leave this ${spaceLabel(ls.mode)}`,
          ps: `If you have created ${courseLabel(ls.mode, true)} in this ${spaceLabel(ls.mode)}, they will be transferred to the owner of the ${spaceLabel(ls.mode)}.`,
          type: spaceLabel(ls.mode),
          action: 'leave'
        }
      })
      .afterClosed()
      .pipe(
        filter(val => val === 'ok'),
        switchMap(a => {
          return this._courseApiService.unsubscribeLearnspace(ls.id, this._authservice.wondaUser.id);
        })
      )
      .subscribe(() => this._router.navigate([`/`]));
  }

  addCourse(ls: Learnspace): void {
    this._dialog
      .open(TemplatePickerDialogComponent, {
        panelClass: 'learnspace-theme',
        maxWidth: 'min(80vw, 1200px)',
        minWidth: 'min(80vw, 768px)',
        height: 'auto',
        maxHeight: 'min(90vh, 800px)',
        minHeight: 'min(90vh, 388px)',
        data: { learnspace: ls, route: this._route }
      });
  }

  updatePermission(event: any): void {
    if (this.xpLeft === undefined) { return; }

    if (event.action === 'add') {
      this.xpLeft --;
    } else if (event.action === 'remove') {
      this.xpLeft ++;
    }
  }

  showAnalytics(): void {
    this._router.navigate([`analytics${this._router.url}`]);
  }
}
